import React, { useState, useEffect, useContext, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../ShipmentSelectScanType.css";
import jsPDF from "jspdf";
import { ToastContainer, toast } from "react-toastify";

import Icon9 from "../../../assest/images/Icon9.png";
import Select from "react-select";
import { UserContext } from "../../common/UserContext";
import config from "../../../envconfig";
import "../ShipmentInwardScan/Popup.css";
import { IoCaretDownOutline, IoCaretUpOutline } from "react-icons/io5";

function ShipOutScanByProduct() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);
  const { SHPH_ShipmentID } = useParams();
  const navigate = useNavigate();
  const [RSN, setRSN] = useState("");
  const [UniqueRSN, setUniqueRSN] = useState(new Set());
  const [SelectedShipmentID, setSelectedShipmentID] = useState(null);
  const [ProductNames, setProductNames] = useState([]);
  const [ProductShipment, setProductShipment] = useState([]);
  const [SelectedProduct, setSelectedProduct] = useState("");
  const [ExtractedGTIN, setExtractedGTIN] = useState(null);
  const [selectedProductShipment, setSelectedProductShipment] = useState([]);
  const [ScannedResultForProduct, setScannedResultForProduct] = useState("");
  const [shipRandomrsn, setShipRandomrsn] = useState({ getparentrsn: "" });
  const [fetchedData, setFetchedData] = useState("");
  const [notAddedValues, setNotAddedValues] = useState([]);
  const [CheckedItems, setCheckedItems] = useState(new Set());
  const [isRSNScanned, setIsRSNScanned] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(false); // Step 1: Track button click state
  const [inputMode, setInputMode] = useState("scan"); // "scan" or "manual"
  const inputRef = useRef(null); // Add useRef to reference the input element
  const debounceTimer = useRef(null);
  const [manualInputEnabled, setManualInputEnabled] = useState(false);
  const [SelectedProductID, setSelectedProductID] = useState(null);
  const [saveCallCount, setSaveCallCount] = useState(0); // Initialize call count state
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState(null); // State to store the popup data

  const [rsnTree, setRsnTree] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState(new Set());
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  // ================== FOR POPUP BOX ====================
  const [isPopupVisibleRSN, setPopupVisibleRSN] = useState(false);
  const [confirmationCallback, setConfirmationCallback] = useState(null);
  const [cancelCallback, setCancelCallback] = useState(null); // Cancel callback for "NO"
  const [message, setMessage] = useState("");

  const handleInputModeChange = (mode) => {
    setInputMode(mode);
    setManualInputEnabled(mode === "manual");
    setScannedResultForProduct("")
    logAction(`Manual RSN Entry selected`);
  };
  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);
  //=======================================  

const renderRSNNode = (node, level = 0, isRoot = false, insideBox = false) => {
  const hasChildren = node.children && node.children.length > 0;
  const isExpanded = expandedNodes.has(node.IRS_RandomNo);

  return (
    <div key={node.IRS_RandomNo} style={{ marginLeft: level * 20 }}>
      {/* Root Node */}
      {isRoot ? (
        <>
          <input
            className="form-check-input"
            type="checkbox"
            checked={CheckedItems.has(node.IRS_RandomNo)}
            onChange={(e) => handleCheckBoxChange(e, node.IRS_RandomNo)}
            value={node.IRS_RandomNo}
            id={`check-${node.IRS_RandomNo}`}
          />
          <label
            className="form-check-label"
            htmlFor={`check-${node.IRS_RandomNo}`}
            style={{ color: "#465a64", marginLeft: "6px" }}
          >
            {node.IRS_RandomNo}
          </label>

          {/* Expand/Collapse button for root */}
          {hasChildren && (
            <button
              type="button"
              className="btn btn-link btn-sm"
              style={{ fontSize: "12px", padding: "2px 6px", marginLeft: "6px" }}
              onClick={() => {
                const newExpanded = new Set(expandedNodes);
                if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                else newExpanded.add(node.IRS_RandomNo);
                setExpandedNodes(newExpanded);
              }}
            >
              {isExpanded ? "➖" : "➕"}
            </button>
          )}
        </>
      ) : (
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* Always reserve space for expand/collapse if inside box */}
          {insideBox && (
            <div style={{ width: "18px", textAlign: "center" }}>
              {hasChildren ? (
                <button
                  type="button"
                  className="btn btn-link btn-sm"
                  style={{
                    fontSize: "12px",
                    padding: "1px 3px",
                    lineHeight: "1",
                  }}
                  onClick={() => {
                    const newExpanded = new Set(expandedNodes);
                    if (isExpanded) newExpanded.delete(node.IRS_RandomNo);
                    else newExpanded.add(node.IRS_RandomNo);
                    setExpandedNodes(newExpanded);
                  }}
                >
                  {isExpanded ? "➖" : "➕"}
                </button>
              ) : (
                <span style={{ display: "inline-block", width: "12px" }} />
              )}
            </div>
          )}

          {/* Label */}
          <span style={{ color: "#465a64", marginLeft: "6px" }}>
            {node.IRS_RandomNo}
          </span>
        </div>
      )}

      {/* Children */}
      {hasChildren && isExpanded && (
        <div
          style={{
            marginTop: 6,
            border: isRoot ? "1px solid #ccc" : "none",
            borderRadius: isRoot ? "6px" : "0",
            padding: isRoot ? "10px" : "0",
          }}
        >
          {node.children.map((child) =>
            renderRSNNode(child, level + 1, child.isRoot, true) // insideBox = true
          )}
        </div>
      )}
    </div>
  );
};


  // ========================== Log File ===============================
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Shipment Outward Scanning By Vendor :",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };
  //====================================================================

  // useEffect(() => {
  //   const fetchProductNames = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${config.API_URL}/Product_code/${SHPH_ShipmentID}`
  //       );
  //       const data = response.data;

  //       if (response.status === 200) {
  //         const uniqueProductNames = Array.from(
  //           new Set(
  //             data.PL_ProductCode.map((product) => ({
  //               value: product.PL_ProductName,
  //               label: product.PL_ProductName,
  //             }))
  //           )
  //         );
  //         setProductNames(uniqueProductNames);
  //       } else {
  //         console.error("Error fetching Product Names:", data.error);
  //         toast.error("Failed to fetch Product Names");
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch Product Names:", error);
  //       toast.error("Failed to fetch Product Names");
  //     }
  //   };

  //   fetchProductNames();
  // }, [SHPH_ShipmentID]);
useEffect(() => {
  const fetchProductNames = async () => {
    try {
      const response = await axios.get(
        `${config.API_URL}/Product_code/${SHPH_ShipmentID}`
      );
      const data = response.data;

      if (response.status === 200) {
        const uniqueProductNames = Array.from(
          new Set(
            data.PL_ProductCode.map((product) => ({
              value: product.PL_ProductName,
              label: product.PL_ProductName,
            }))
          )
        );
        setProductNames(uniqueProductNames);

        // Auto-select the first product from the dropdown
        if (uniqueProductNames.length > 0 && !SelectedProduct) {
          const firstProduct = uniqueProductNames[0];
          setSelectedProduct(firstProduct.value);
          
          // Don't call handleAutoProductSelection here - wait for ProductShipment to be populated
          // The data will load automatically because SelectedProduct is set
        }
      } else {
        console.error("Error fetching Product Names:", data.error);
        toast.error("Failed to fetch Product Names");
      }
    } catch (error) {
      console.error("Failed to fetch Product Names:", error);
      toast.error("Failed to fetch Product Names");
    }
  };

  fetchProductNames();
}, [SHPH_ShipmentID]);
  // Add this helper function for auto-selection logic
const handleAutoProductSelection = (selectedProductValue) => {
  if (selectedProductValue && ProductShipment.length > 0) {
    const filteredProductShipment = ProductShipment.filter(
      (shipment) => shipment.PL_ProductName === selectedProductValue
    );

    const existingProductID = new Set(selectedProductShipment.map(item => `${item.PL_ProductName}-${item.PL_ProductId}`));
    const newItems = filteredProductShipment.filter(item => 
      !existingProductID.has(`${item.PL_ProductName}-${item.PL_ProductId}`)
    );
    
    if (newItems.length > 0) {
      setSelectedProductShipment((prevProductShipment) => [
        ...prevProductShipment,
        ...newItems,
      ]);
      const updatedData = [...selectedProductShipment, ...newItems];
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
    }
  }

  // Update ProductNames to mark as disabled
  setProductNames((prevProductNames) =>
    prevProductNames.map((option) =>
      option.value === selectedProductValue
        ? { ...option, isDisabled: true }
        : option
    )
  );

  setManualInputEnabled(false);
};
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        // =========== Newly Added ============
        const storedData = sessionStorage.getItem('shipmentTable')
        if (storedData) {
          const parsedData = JSON.parse(storedData);
          setSelectedProductShipment(parsedData);
          return;
        }
        //=====================================
        // Fetch data from Shipmentlist_vendor API
        const shipmentResponse = await axios.get(
          `${config.API_URL}/Shipmentlist_Product/${SHPH_ShipmentID}`
        );
        const shipmentData = shipmentResponse.data.shipmentData;
        logAction(`Shipment list fetched successfully`);
        // Fetch RSN PackSize data
        const scannedRSNResponse = await axios.get(
          `${config.API_URL}/Scanned_RSN_PackSize_OF_Shipment_Outward_ProductWise/${SHPH_ShipmentID}/${selectedScpId}`
        );
        const rsnPackSizeData = scannedRSNResponse.data.AllRSN_ToOutward;

        const scannedRandomNoResponse = await axios.get(
          `${config.API_URL}/Scanned_RSN_OF_Shipment_Outward/${SHPH_ShipmentID}/${selectedScpId}`
        );
        const rsnRandomNoData = scannedRandomNoResponse.data.AllRSN_ToOutward;
        const shipmentMap = {};
        shipmentData.forEach((shipment) => {
          const matchedRSN = rsnPackSizeData.find(
            (rsn) =>
              rsn.PL_ProductCode === shipment.SHPD_ProductCode &&
              rsn.IRS_ProductID === shipment.inv_productid
          );
          const key = `${shipment.SHPD_ProductCode}-${shipment.inv_productid}`;
          if (!shipmentMap[key]) {
            shipmentMap[key] = {
              ...shipment,
              SHPD_ShipQty: shipment.SHPD_ShipQty,
              SHPD_ScanQty: matchedRSN
                ? shipment.SHPD_ScanQty + matchedRSN.IRS_PackSize
                : shipment.SHPD_ScanQty,
            };
          } else {
            shipmentMap[key].SHPD_ShipQty += shipment.SHPD_ShipQty;
            shipmentMap[key].SHPD_ScanQty += shipment.SHPD_ScanQty;
          }
        });

        const mergedData = Object.values(shipmentMap);
        setProductShipment(mergedData);
  
const rsnTreeDataRaw = await Promise.all(
  rsnRandomNoData.map(async (rsn) => {
    const resp = await axios.get(
      `${config.API_URL}/RSNChainToMap/${rsn.IRS_RandomNo}`
    );
    return resp.data.data; // recursive tree from backend
  })
);

// 🔥 Deduplicate by IRS_RandomNo
const uniqueTreeData = [];
const seen = new Set();
for (const node of rsnTreeDataRaw) {
  if (!seen.has(node.IRS_RandomNo)) {
    seen.add(node.IRS_RandomNo);
    uniqueTreeData.push(node);
  }
}

setRsnTree(uniqueTreeData); // save unique tree in state

        //--------------------------
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };
    if (selectedScpId) {
      fetchAllData();
    }
  }, [SHPH_ShipmentID, selectedScpId, refreshTrigger]);

  // useEffect(() => {
  //   if (SelectedProduct && ProductShipment.length > 0) {
  //     const filteredProductShipment = ProductShipment.filter(
  //       (shipment) => shipment.PL_ProductName === SelectedProduct
  //     ); // PL_ProductName PL_ProductCode

  //     const existingProductID = new Set(selectedProductShipment.map(item => `${item.PL_ProductName}-${item.PL_ProductId}` ));
  //     const newItems = filteredProductShipment.filter(item => 
  //       !existingProductID.has(`${item.PL_ProductName}-${item.PL_ProductId}`)
  //     );

  //     if (newItems.length > 0) {
  //     setSelectedProductShipment((prevProductShipment) => [
  //       ...prevProductShipment,
  //       ...newItems,
  //     ]);
  //     const updatedData = [...selectedProductShipment, ...newItems];
  //     sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
  //    }
  //   } 
  //   // else {
  //   //   setSelectedProductShipment([]);
  //   // }
  // }, [SelectedProduct, ProductShipment]);
//====================================================================

// THIS NEW USEEFFECT HOOK FOR AUTO-SELECTION
useEffect(() => {
  if (selectedProductShipment.length > 0) {
    // If nothing is selected, auto-select the first available product
    if (!SelectedShipmentID && !SelectedProductID) {
      const firstAvailableProduct = selectedProductShipment.find(
        shipment => shipment.SHPD_ShipQty > shipment.SHPD_ScanQty
      );
      
      if (firstAvailableProduct) {
        setSelectedShipmentID(firstAvailableProduct.SHPD_ShipmentMID);
        setSelectedProductID(firstAvailableProduct.PL_ProductId);
        console.log("Auto-selected first product:", {
          shipmentId: firstAvailableProduct.SHPD_ShipmentMID,
          productId: firstAvailableProduct.PL_ProductId,
          productName: firstAvailableProduct.SHPD_ProductName
        });
      }
    } 
    // Auto-switch to next available product when current one is saved
    else {
      const currentShipment = selectedProductShipment.find(
        shipment => shipment.SHPD_ShipmentMID === SelectedShipmentID
      );
      
      if (currentShipment && currentShipment.SHPD_ShipQty === currentShipment.SHPD_ScanQty) {
        const nextAvailableProduct = selectedProductShipment.find(
          shipment => 
            shipment.SHPD_ShipQty > shipment.SHPD_ScanQty && 
            shipment.SHPD_ShipmentMID !== SelectedShipmentID
        );
        
        if (nextAvailableProduct) {
          setSelectedShipmentID(nextAvailableProduct.SHPD_ShipmentMID);
          setSelectedProductID(nextAvailableProduct.PL_ProductId);
          console.log("Auto-switched to next product:", {
            shipmentId: nextAvailableProduct.SHPD_ShipmentMID,
            productId: nextAvailableProduct.PL_ProductId,
            productName: nextAvailableProduct.SHPD_ProductName
          });
          
         
        }
      }
    }
  }
}, [selectedProductShipment, SelectedShipmentID, SelectedProductID]);

//====================================================================
// ==================================================
  const showPopup = (message, onConfirm, onCancel) => {
    setMessage(message);
    setConfirmationCallback(() => onConfirm);
    setCancelCallback(() => onCancel); // Assign cancel callback
    setPopupVisibleRSN(true);
  };

  const handlePopupConfirm = () => {
    if (confirmationCallback) confirmationCallback();
    setPopupVisibleRSN(false);
  };

  const handlePopupClose = () => {
    if (cancelCallback) cancelCallback(); // Run cancel callback if "NO" is clicked
    setPopupVisibleRSN(false);
  };
  // ==================================================
  const FetchProductData = async (rsnValue, shipment) => {
    try {
      if (!shipRandomrsn.getparentrsn) {
        console.error("shipRandomrsn.getparentrsn is undefined");
        setScannedResultForProduct("");
        return;
      }
      if (SelectedShipmentID) {

        if (!ExtractedGTIN) { 
        const RSNStatus = await fetch(
          // `${config.API_URL}/RSN_Status_Outward_ProductwiseScanning/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}`
          `${config.API_URL}/RSN_Status_Outward_NonGTIN/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}`
        );
        if (RSNStatus.ok) {
          const data = await RSNStatus.json();
          console.log("Fetched Data:", data);

          if (data.IRS_Status === 6) {
            const RES = await fetch(
              `${config.API_URL}/ChildRSN_Lock_Outward/${data.IRS_RandomNo}`
            );
            if (RES.ok) {
              const data = await RES.json();
              console.log("Fetched Data:", data);
            } else {
              console.error("Error fetching the data");
            }

            const response = await fetch(
              `${config.API_URL}/ParentRSN_PackSize_Outward/${data.IRS_RandomNo}`
            );
            if (response.ok) {
              const data = await response.json();
              console.log("Fetched Data from ParentRSN_PackSize:", data);
              setFetchedData(data.PL_ProductCode);

              if (data.IRS_ParentRandomNo) {
                showPopup(
                  "Are you sure you want to disaggregate the Parent RSN ?",
                  async () => {
                    try {
                      const packSizeResponse = await fetch(
                        `${config.API_URL}/ParentRSN_Disaggregation_Outward/${data.IRS_RandomNo}`
                      );
                      if (packSizeResponse.ok) {
                        const packSizeData = await packSizeResponse.json();
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        setFetchedData(
                          packSizeData.PL_ProductCode,
                          packSizeData.IRS_PackSize
                        );
                        setShipRandomrsn(packSizeData);
                        HandleAddRSNinBoxForProduct(
                          packSizeData.IRS_PackSize,
                          packSizeData.PL_ProductCode
                        );
                        logAction(
                          `Parent RSN of  ${data.IRS_RandomNo} disaggrigated successfully`
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                        setScannedResultForProduct("");
                      }
                    } catch (error) {
                      console.error("Error fetching IRS_PackSize data:", error);
                    }
                  },
                  async () => {
                    try {
                      const response = await axios.put(
                        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${ScannedResultForProduct}`
                      );
                      if (response.status === 200) {
                        console.log(
                          `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
                        );
                        setScannedResultForProduct("");
                      } else {
                        console.error(
                          `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
                        );
                        setScannedResultForProduct("");
                      }
                    } catch (error) {
                      console.error("Error updating IRS_Status:", error);
                      setScannedResultForProduct("");
                    }
                  }
                );
              } else {
                setFetchedData(data.IRS_PackSize);
                setShipRandomrsn(data);
                HandleAddRSNinBoxForProduct(
                  data.IRS_PackSize,
                  data.PL_ProductCode
                );
                logAction(`RSN  ${data.IRS_RandomNo} Added successfully`);
              }
            } else {
              console.error("Error fetching the data");
              setScannedResultForProduct("");
            }
          } else if (data.IRS_Status === 22) {
        //  } else if (shipment.SHPD_ScanQty === shipment.SHPD_ShipQty) {
            if (!isRSNScanned) {
              toast.warning("RSN already scanned");
              logAction(`RSN  ${data.IRS_RandomNo} RSN already scanned`);
              setScannedResultForProduct("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          } else if (data.IRS_Status === 21) {
            if (!isRSNScanned) {
              toast.warning("Invalid RSN");
              setScannedResultForProduct("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          } 
        } else if (RSNStatus.status === 404) {
          //toast.warning("Invalid RSN");
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            console.log("invalid RSN");
            setScannedResultForProduct("");
            console.error("Error fetching the RSN Status");
            return;
          } else {
            console.log("RSN Scanned");
          }
        } else {
          setScannedResultForProduct("");
          console.error("Error fetching the RSN Status");
        }
      } else {
         const RSNStatus = await fetch(
          // `${config.API_URL}/RSN_Status_Outward_ProductwiseScanning/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}`
          `${config.API_URL}/RSN_Status_Outward/${shipRandomrsn.getparentrsn}/${selectedScpId}/${SelectedProductID}/${ExtractedGTIN}`
        );
        if (RSNStatus.ok) {
          const data = await RSNStatus.json();
          console.log("Fetched Data:", data);

          if (data.IRS_Status === 6) {
            const RES = await fetch(
              `${config.API_URL}/ChildRSN_Lock_Outward/${data.IRS_RandomNo}`
            );
            if (RES.ok) {
              const data = await RES.json();
              console.log("Fetched Data:", data);
            } else {
              console.error("Error fetching the data");
            }

            const response = await fetch(
              `${config.API_URL}/ParentRSN_PackSize_Outward/${data.IRS_RandomNo}`
            );
            if (response.ok) {
              const data = await response.json();
              console.log("Fetched Data from ParentRSN_PackSize:", data);
              setFetchedData(data.PL_ProductCode);

              if (data.IRS_ParentRandomNo) {
                showPopup(
                  "Are you sure you want to disaggregate the Parent RSN ?",
                  async () => {
                    try {
                      const packSizeResponse = await fetch(
                        `${config.API_URL}/ParentRSN_Disaggregation_Outward/${data.IRS_RandomNo}`
                      );
                      if (packSizeResponse.ok) {
                        const packSizeData = await packSizeResponse.json();
                        console.log(
                          "Fetched Data from ParentRSN_Disaggregation:",
                          packSizeData
                        );
                        setFetchedData(
                          packSizeData.PL_ProductCode,
                          packSizeData.IRS_PackSize
                        );
                        setShipRandomrsn(packSizeData);
                        HandleAddRSNinBoxForProduct(
                          packSizeData.IRS_PackSize,
                          packSizeData.PL_ProductCode
                        );
                        logAction(
                          `Parent RSN of  ${data.IRS_RandomNo} disaggrigated successfully`
                        );
                      } else {
                        console.error("Error fetching IRS_PackSize data");
                        setScannedResultForProduct("");
                      }
                    } catch (error) {
                      console.error("Error fetching IRS_PackSize data:", error);
                    }
                  },
                  async () => {
                    try {
                      const response = await axios.put(
                        `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${ScannedResultForProduct}`
                      );
                      if (response.status === 200) {
                        console.log(
                          `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
                        );
                        setScannedResultForProduct("");
                      } else {
                        console.error(
                          `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
                        );
                        setScannedResultForProduct("");
                      }
                    } catch (error) {
                      console.error("Error updating IRS_Status:", error);
                      setScannedResultForProduct("");
                    }
                  }
                );
              } else {
                setFetchedData(data.IRS_PackSize);
                setShipRandomrsn(data);
                HandleAddRSNinBoxForProduct(
                  data.IRS_PackSize,
                  data.PL_ProductCode
                );
                logAction(`RSN  ${data.IRS_RandomNo} Added successfully`);
              }
            } else {
              console.error("Error fetching the data");
              setScannedResultForProduct("");
            }
          } else if (data.IRS_Status === 22) {
        //  } else if (shipment.SHPD_ScanQty === shipment.SHPD_ShipQty) {
            if (!isRSNScanned) {
              toast.warning("RSN already scanned");
              logAction(`RSN  ${data.IRS_RandomNo} RSN already scanned`);
              setScannedResultForProduct("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          } else if (data.IRS_Status === 21) {
            if (!isRSNScanned) {
              toast.warning("Invalid RSN");
              setScannedResultForProduct("");
              return;
            } else {
              console.log("RSN Scanned");
            }
          } 
        } else if (RSNStatus.status === 404) {
          //toast.warning("Invalid RSN");
          if (!isRSNScanned) {
            toast.warning("Invalid RSN");
            console.log("invalid RSN");
            setScannedResultForProduct("");
            console.error("Error fetching the RSN Status");
            return;
          } else {
            console.log("RSN Scanned");
          }
        } else {
          setScannedResultForProduct("");
          console.error("Error fetching the RSN Status");
        }
      }
      } else {
        toast.warning("Please Select a Product");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setScannedResultForProduct("");
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus(); // Focus the input field
    }
  }, [inputMode]);
  

  useEffect(() => {
    if (inputMode === "scan" && ScannedResultForProduct) {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
      debounceTimer.current = setTimeout(() => {
        if (
          ScannedResultForProduct &&
          !RSN.split("\n").includes(ScannedResultForProduct)
        ) {
          setRSN((prevRSN) => prevRSN + "\n");
          // Clear the input field after submission
          setScannedResultForProduct("");
        }
        FetchProductData(ScannedResultForProduct);
        setScannedResultForProduct("");
      }, 50); // 1 second delay
      return () => {
        if (debounceTimer.current) {
          clearTimeout(debounceTimer.current);
        }
      };
    }
  }, [ScannedResultForProduct, shipRandomrsn.getparentrsn, inputMode]);

  const handleManualSubmit = () => {
    if (inputMode === "manual" && ScannedResultForProduct) {
      FetchProductData(ScannedResultForProduct);

      if (
        ScannedResultForProduct &&
        !RSN.split("\n").includes(ScannedResultForProduct)
      ) {
        setRSN((prevRSN) => prevRSN + "\n");
        setScannedResultForProduct("");
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
          }
        }, 0); // Ensure focus after state update
      }
    } else if (!ScannedResultForProduct || ScannedResultForProduct.trim() === "")  {
          toast.warning("Please Enter RSN");
  }
  };

  const HandleInputChange = async (e) => {
    const scannedValue = e.target.value;
    setScannedResultForProduct(scannedValue);
    setShipRandomrsn({ getparentrsn: scannedValue });
    setFetchedData("");

  }
  
  let scanTimeout;

  const HandleScanChangeForProduct = async (e) => {
    // const scannedValue = e.target.value;
       const scannedValue = e.target.value.trim();
       if (scanTimeout) clearTimeout(scanTimeout);

    scanTimeout = setTimeout(() => {
     
      const rsnMatch = scannedValue.match(/\((21|00)\)([A-Z0-9]{8,25})(?=\(01\)|\(10\)|\(17\)|$)/i);
      // Match GTIN: (01) followed by 8–25 digits
      const gtinMatch = scannedValue.match(/\(01\)(\d{8,25})/);
      let extracted = '';
      let extractedGTIN = null;
      if (rsnMatch && /^[A-Z0-9]{8,25}$/.test(rsnMatch[2])) {
        extracted = rsnMatch[2];
      } else if (/^[A-Z0-9]{8,25}$/i.test(scannedValue)) {
        extracted = scannedValue;
      }

      if (gtinMatch && /^\d{8,25}$/.test(gtinMatch[1])) {
      extractedGTIN = gtinMatch[1];
    }

      if (extracted) {
        setScannedResultForProduct(extracted);
        setShipRandomrsn({ getparentrsn : extracted })
        setFetchedData('')
        console.log(' Extracted RSN :', extracted)
      } else {
        console.log('Extracted RSN:', extracted);
        setScannedResultForProduct('')
      }
      if (extractedGTIN) {
        setExtractedGTIN(extractedGTIN);
        console.log("Extracted GTIN:", extractedGTIN);
      } else {
        setExtractedGTIN(null);
      }

    if (inputRef.current) inputRef.current.value = '';
    }, 50)
  };

  const handleCheckBoxChange = (e, item) => {
    if (e.target.checked) {
      setCheckedItems((prevCheckedItems) =>
        new Set(prevCheckedItems).add(item)
      );
      sessionStorage.removeItem("CheckedItems");
    } else {
      const newCheckedItems = new Set(CheckedItems);
      newCheckedItems.delete(item);
      setCheckedItems(newCheckedItems);
      sessionStorage.removeItem("RSN");
      sessionStorage.removeItem("CheckedItems");
    }
  };

  // Handle "Select All" functionality
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
 
    let allItems = new Set();

    RSN.split("\n")
    .filter((line) => line.trim() !=="")
    .forEach((line) => allItems.add(line));

    const collectAllNodes = (node) => {
      allItems.add(node.IRS_RandomNo);
      if (node.children && node.children.length > 0) {
        node.children.forEach(collectAllNodes);
      }
    }
  if (rsnTree) {
    rsnTree.forEach(collectAllNodes);
  }
  setCheckedItems(allItems)
  } else {
      setCheckedItems(new Set());
    }
  };



const HandleProductChange = async (selectedOption) => {
  const selectedProduct = selectedOption?.value;
  setSelectedProduct(selectedProduct);
  handleAutoProductSelection(selectedProduct);
}; 


// Add this useEffect to handle auto-selection after ProductShipment data is available
useEffect(() => {
  if (SelectedProduct && ProductShipment.length > 0) {
    // This will trigger the same logic as manual selection
    const filteredProductShipment = ProductShipment.filter(
      (shipment) => shipment.PL_ProductName === SelectedProduct
    );

    const existingProductID = new Set(selectedProductShipment.map(item => `${item.PL_ProductName}-${item.PL_ProductId}`));
    const newItems = filteredProductShipment.filter(item => 
      !existingProductID.has(`${item.PL_ProductName}-${item.PL_ProductId}`)
    );
    
    if (newItems.length > 0) {
      setSelectedProductShipment((prevProductShipment) => [
        ...prevProductShipment,
        ...newItems,
      ]);
      const updatedData = [...selectedProductShipment, ...newItems];
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedData));
    }

    // Mark as disabled in dropdown
    setProductNames((prevProductNames) =>
      prevProductNames.map((option) =>
        option.value === SelectedProduct
          ? { ...option, isDisabled: true }
          : option
      )
    );
    
    setManualInputEnabled(false);
  }
}, [SelectedProduct, ProductShipment]);


  const handleKeyDown = (e) => {
    if (!e.key.match(/^[\r\n\t]*$/)) {
      HandleScanChangeForProduct(e)
    }
  };
  const preventPaste = (e) => {
    e.preventDefault();
  };
  const HandleAddRSNinBoxForProduct = async (packSize, productCode) => {
    let updatedProductShipment = [...selectedProductShipment];
    let found = false;
    if (ScannedResultForProduct && !UniqueRSN.has(ScannedResultForProduct)) {
      if (SelectedShipmentID && SelectedProductID) {
        for (let i = 0; i < updatedProductShipment.length; i++) {
          const shipment = updatedProductShipment[i];
          if (shipment.SHPD_ShipmentMID === SelectedShipmentID &&
            SelectedProductID === shipment.PL_ProductId
          ) {
            if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
              toast.warning("Scanning limit reached");
              logAction(
                `Scan Quantity reached the limit please select another product or scan RSN of for another product `
              );

              return;
            } else {
             
                setRSN((prevContent) => {
  const updated = prevContent + ScannedResultForProduct + "\n";
  const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !== ""))];
  return uniqueLines.join("\n");
});
              shipment.SHPD_ScanQty += packSize;
              setScannedResultForProduct("");
              setUniqueRSN(
                (prevSerials) =>
                  new Set(prevSerials.add(ScannedResultForProduct))
              );
              logAction(
                `RSN: ${ScannedResultForProduct} is Scanned For Shipment code: ${shipment.SHPH_ShipmentCode} Shipment ID: ${SHPH_ShipmentID} and For SCP: ${shipment.SHPD_ProductName}`
              );

              found = true;
            }
            break;
          }
        }
      } else {
        for (let i = 0; i < updatedProductShipment.length; i++) {
          const shipment = updatedProductShipment[i];
          if (shipment.SHPD_ProductCode === productCode) {
            if (shipment.SHPD_ScanQty + packSize > shipment.SHPD_ShipQty) {
              toast.warning("Scanning limit reached");
              logAction(
                `Scan Quantity reached the limit please select another product or scan RSN of for another product `
              );

              return;
            } else {
              
                setRSN((prevContent) => {
  const updated = prevContent + ScannedResultForProduct + "\n";
  const uniqueLines = [...new Set(updated.split("\n").filter((l) => l.trim() !== ""))];
  return uniqueLines.join("\n");
});
              shipment.SHPD_ScanQty += packSize;
              setScannedResultForProduct("");
              setUniqueRSN(
                (prevSerials) =>
                  new Set(prevSerials.add(ScannedResultForProduct))
              );
              logAction(
                `RSN: ${ScannedResultForProduct} is Scanned For Shipment code: ${shipment.SHPH_ShipmentCode} Shipment ID: ${SHPH_ShipmentID} and For SCP: ${shipment.SHPD_ProductName}`
              );
              found = true;
            }
            break;
          }
        }
      }
      if (found) {
        await fetchShipmentRSNLockForChild(SelectedShipmentID);
        await fetchShipmentRSNLockForParentRSN(SelectedShipmentID);
      
       // 🔥 Fetch RSN chain immediately for this new scanned RSN
      try {
        const resp = await axios.get(
          `${config.API_URL}/RSNChainToMap/${ScannedResultForProduct}`
        );
        const newChain = resp.data.data;

        setRsnTree((prevTree) => {
          if (!prevTree || prevTree.length === 0) return [newChain];

          // avoid duplicate root
          const exists = prevTree.some(
            (root) => root.IRS_RandomNo === newChain.IRS_RandomNo
          );
          return exists ? prevTree : [...prevTree, newChain];
        });
      } catch (err) {
        console.error("Failed to fetch RSN chain for new RSN:", err);
      }
      
      
      
      } else {
        setNotAddedValues((prevValues) => [
          ...prevValues,
          ScannedResultForProduct,
        ]);
        await updateScannedIRSStatus();
      }
      setSelectedProductShipment(updatedProductShipment);
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedProductShipment));
      setNotAddedValues("");
    } else if (!ScannedResultForProduct) {
     // toast.warning("Serial number cannot be empty.");
      await updateScannedIRSStatus();
      setNotAddedValues("");
    } else {
      //toast.warning("Serial number already exists.");
      await updateScannedIRSStatus();
      setNotAddedValues("");
    }
  };

  const updateScannedIRSStatus = async () => {
    try {
      const response = await axios.put(
        `${config.API_URL}/Update_Bymistake_Scanned_RSN/${ScannedResultForProduct}`
      );
      if (response.status === 200) {
        console.log(
          `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
        );
        setScannedResultForProduct("");
      } else {
        console.log(
          `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
        );
        setScannedResultForProduct("");
      }
    } catch (error) {
      console.error("Error updating IRS_Status:", error);
      console.log(
        `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
      );
      setScannedResultForProduct("");
    }
  };

  //===== Not Added Value =====
  useEffect(() => {
    const updateIRSStatus = async () => {
      try {
        for (const value of notAddedValues) {
          const response = await axios.put(
            `${config.API_URL}/Re_Update_Scanned_IRS_Status_Outward/${value}`
          );
          if (response.status === 200) {
            console.log(
              `IRS_Status updated successfully for value '${ScannedResultForProduct}'`
            );
          } else {
            console.log(
              `Failed to update IRS_Status for value '${ScannedResultForProduct}'`
            );
          }
        }
        setNotAddedValues("");
      } catch (error) {
        console.error("Error updating IRS_Status:", error);
      }
    };
    if (notAddedValues.length > 0) {
      updateIRSStatus();
    }
  }, [notAddedValues]);




const removeSelectedItemsAndUpdateStatus = async () => {
  try {
    const selectedItems = Array.from(CheckedItems);

    if (selectedItems.length === 0) {
      toast.warn("Please select a minimum one serial number");
      logAction("Please select a minimum one serial number");
      return;
    }

    // --- API: Update Removed RSN Status and get product information
    const response = await axios.put(
      // `${config.API_URL}/Update_Removed_RSN_Status_Outward`,
      `${config.API_URL}/Update_Removed_RSN_Status_Outward`,
      { IRS_RandomNos: selectedItems }
    );

    if (response.status === 200) {
      logAction(
        `IRS_Status updated successfully for the selected items ${selectedItems}`
      );

      const { packSizes } = response.data;

      // --- Group IRS_PackSize by ProductCode (only for the relevant product)
      const totalPackSizeByProduct = packSizes.reduce((acc, packSize) => {
        const { PL_ProductCode, IRS_PackSize, IRS_ProductID } = packSize;
        // Only process items that belong to the currently selected product
        const key = `${PL_ProductCode}-${IRS_ProductID}`;
        acc[key] = (acc[key] || 0) + IRS_PackSize;
        // if (IRS_ProductID === SelectedProductID) {
        //   acc[IRS_ProductID] = (acc[IRS_ProductID] || 0) + IRS_PackSize;
        // }
        return acc;
      }, {});

      // --- Update selectedProductShipment (subtract IRS_PackSize from ScanQty only for the relevant product)
      const updatedShipments = selectedProductShipment.map((shipment) => {
        // Only update the shipment that matches the selected product ID
        const key = `${shipment.SHPD_ProductCode}-${shipment.PL_ProductId}`;
        const totalPackSize = totalPackSizeByProduct[key] || 0;
        shipment.SHPD_ScanQty = Math.max(
          shipment.SHPD_ScanQty - totalPackSize
        );
       
        return shipment; // Return unchanged for other products
      });

      setSelectedProductShipment(updatedShipments);
      sessionStorage.setItem('shipmentTableData', JSON.stringify(updatedShipments));

      // --- Update child RSN status
      await axios.post(`${config.API_URL}/ChildRSN_Status_OutwardScan`, {
        IRS_RandomNos: selectedItems,
      });

      // --- Update RSN text area
      const remainingRSN = RSN.split("\n")
        .map((line) => line.trim())
        .filter((line) => !selectedItems.includes(line))
        .join("\n");

      setRSN(remainingRSN.trim());

      // --- Update rsnTree (remove from box UI)
      setRsnTree((prevTree) => {
        if (!prevTree) return prevTree;

        const removeNodes = (node) => {
          if (!node.children) return node;
          return {
            ...node,
            children: node.children
              .filter((child) => !selectedItems.includes(child.IRS_RandomNo))
              .map((child) => removeNodes(child)),
          };
        };

        return prevTree
          .filter((root) => !selectedItems.includes(root.IRS_RandomNo))
          .map((root) => removeNodes(root));
      });

      // --- Clear checked items + UI cleanup
      setCheckedItems(new Set());
      selectedItems.forEach((item) => {
        if (UniqueRSN.has(item)) {
          UniqueRSN.delete(item);
        }
      });

      toast.success(`Selected RSN removed successfully`);

      const selectAllCheckbox = document.getElementById("selectAll");
      if (selectAllCheckbox) {
        selectAllCheckbox.checked = false;
      }

      setRefreshTrigger((prev) => prev + 1);
      document
        .getElementById("RSNInput")
        ?.dispatchEvent(new Event("input"));
    } else {
      console.error("Failed to update IRS_Status for the selected items");
    }
  } catch (error) {
    console.error("Error updating IRS_Status:", error);
  }
};


  const updateScanQuantity = async (shipment) => {
    const {
      SHPD_ShipmentID,
      SHPD_ProductCode,
      SHPD_ScanQty,
      SHPH_ShipmentCode,
    } = shipment;
    try {
      // Step 1: Update scan quantity
      const updateScanResponse = await axios.put(
        `${config.API_URL}/Update_Scanqty_Outward`,
        {
          SHPD_ShipmentID,
          SHPD_ProductCode,
          SHPD_ScanQty,
        }
      );
      if (updateScanResponse.status !== 200) {
        toast.error(
          `Failed to update scan quantity for Shipment ID ${SHPD_ShipmentID}`
        );
        return;
      }
      // toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully`);
       toast.success(`Shipment : ${SHPH_ShipmentCode} saved successfully.`, {
        toastId: `shipment-${SHPD_ShipmentID}`,
      });
      logAction(`Shipment : ${SHPH_ShipmentCode} saved successfully.`);
      // Extract SHPH_FromSCPCode and PL_ProductId from the update scan response
      const { SHPH_FromSCPCode, PL_ProductId } =
        updateScanResponse.data.updatedData;
      // Step 2: Fetch inventory data
      const inventoryResponse = await axios.get(
        `${config.API_URL}/Inventory_Outward/${SHPH_FromSCPCode}/${PL_ProductId}`
      );
      if (inventoryResponse.status !== 200) {
        //toast.error( `Failed to fetch inventory data for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`);
        logAction(
          `Failed to fetch inventory data for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`
        );
        return;
      }
      const inventoryData = inventoryResponse.data.inventorydata[0];
      const { inv_blockqty, inv_availableqty } = inventoryData;

      // Step 3: Subtract SHPD_ScanQty from inv_blockqty and inv_availableqty
      const updatedBlockQty = inv_blockqty - SHPD_ScanQty;
      const updatedAvailableQty = inv_availableqty - SHPD_ScanQty;

      // Step 4: Update inventory data
      const updateInventoryResponse = await axios.put(
        `${config.API_URL}/Inventory_Outward/${SHPH_FromSCPCode}/${PL_ProductId}`,
        {
          inv_blockqty: updatedBlockQty,
          inv_availableqty: updatedAvailableQty,
        }
      );
      if (updateInventoryResponse.status !== 200) {
        logAction(
          `Failed to update inventory for SCPID ${SHPH_FromSCPCode} and Product ID ${PL_ProductId}`
        );
        return;
      }
      setTimeout(() => {
        navigate("/ShipOutScanPendingList");
      }, 2000);
    } catch (error) {
      console.error(
        `Error processing request for Shipment ID ${SHPD_ShipmentID}:`,
        error
      );
      toast.error(
        `Failed to process request for Shipment ID ${SHPH_ShipmentCode}`
      );
    }
  };

  // ==================== Used For Shipment Lock =========================
  const fetchShipmentRSNLockForChild = async (SelectedShipmentID) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Outward/${SelectedShipmentID}/${SHPH_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);

      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ChildRSNLockToShipMentID_Outward/${shipRandomrsn.getparentrsn}`,
          {
            IRS_ShipmentID: item.IRS_ShipmentID,
            IRS_ToSCP: item.IRS_ToSCP,
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };

  const fetchShipmentRSNLockForParentRSN = async (SelectedShipmentID) => {
    try {
      const response = await axios.get(
        `${config.API_URL}/ShipmentData_For_RSN_Outward/${SelectedShipmentID}/${SHPH_ShipmentID}`
      );
      const shipmentData = response.data.ShipmentForRSN;
      console.log("Shipment Data:", shipmentData);

      for (const item of shipmentData) {
        await axios.put(
          `${config.API_URL}/ParentRSNLockToShipMentID_Outward/${shipRandomrsn.getparentrsn}`,
          {
            IRS_ShipmentID: item.IRS_ShipmentID,
            IRS_ToSCP: item.IRS_ToSCP,
            IRS_PhysicalLocation: item.IRS_PhysicalLocation,
          }
        );

        const packSizeResponse = await axios.get(
          `${config.API_URL}/ParentRSN_Lock_Update_Outward/${shipRandomrsn.getparentrsn}/${item.IRS_ShipmentID}/${item.IRS_ToSCP}`
        );

        if (packSizeResponse.status === 200) {
          const packSizeData = packSizeResponse.data;
          console.log(
            "Fetched Data from ParentRSN_Disaggregation:",
            packSizeData
          );
          //=======================//===================//===============//
          const parentRSNResponse = await fetch(
            `${config.API_URL}/Disaggrigated_RSN_History_Outward`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                IRS_RandomNo: shipRandomrsn.getparentrsn,
              }),
            }
          );
          const parentRSNData = await parentRSNResponse.json();
          if (parentRSNResponse.ok && parentRSNData.IRS_ParentRandomNo) {
            const parentRandomNo = parentRSNData.IRS_ParentRandomNo;
            logAction(
              `The Parent RSN : ${parentRandomNo.join(", ")} of RSN ${
                shipRandomrsn.getparentrsn
              } of Shipment ID : ${SHPH_ShipmentID} Disaggregated Successfully`
            );
          }
          //=======================//===================//===============//
          console.log(
            "ShipmentID",
            item.IRS_ShipmentID,
            "SHPD SCP ID",
            item.IRS_ToSCP
          );
        } else {
          console.error("Error fetching IRS_PackSize data");
        }
      }
    } catch (error) {
      console.error("Error fetching shipment data:", error);
    }
  };

  // =====================================================================

  const handleSave = async (e) => {
    e.preventDefault();
    // Check if the function has already been called
    if (saveCallCount > 0) {
      console.log("handleSave function already called, ignoring subsequent calls.");
      return; // Disable further execution
    }
    // Increase the call count
    setSaveCallCount((prevCount) => prevCount + 1);
    try {
      for (const shipment of selectedProductShipment) {
        await updateScanQuantity(shipment);
      }
      await callInsertIRSInfoAPI();
      console.log(`Shipment Outward Scanning Completed`);
      // ========== Newly Added ====================
      sessionStorage.removeItem('shipmentTableData')
      // ===========================================
      setIsSaveButtonDisabled(true);
    } catch (error) {
      console.error("Error updating scan quantities");
      setSaveCallCount(0);
    }
  };
  //==========================================================
  const callInsertIRSInfoAPI = async () => {
  
    //==========  Newly Added ===========
  const textareaRSNs = Array.from(
    new Set(RSN.split("\n").filter((line) => line.trim() !== ""))
  );
  
  // Collect RSNs from rsnTree (including all children)
  const treeRSNs = [];
  const collectAllNodes = (node) => {
    treeRSNs.push(node.IRS_RandomNo);
    if (node.children && node.children.length > 0) {
      node.children.forEach(collectAllNodes);
    }
  };
  
  if (rsnTree) {
    rsnTree.forEach(collectAllNodes);
  }
  
  // Combine and deduplicate all RSNs
  const allRSNValues = Array.from(new Set([...textareaRSNs, ...treeRSNs]));
  //======================================  
  
  if (allRSNValues.length === 0) {
      console.log("No RSNs available to insert.");
      return;
    }
    console.log("Calling IRS info API with RSNs:", allRSNValues);

    try {
      const response = await axios.post(
        `${config.API_URL}/All_RSN_History_Insertion_Outward`,
        {
          IRS_RandomNos: allRSNValues, // Send all RSNs to the API
        }
      );

      if (response.status === 200) {
        console.log(
          "Data successfully inserted into rsnhistoryinfo:",
          response.data
        );
      } else {
        console.log("Failed to insert IRS info:", response);
      }
    } catch (error) {
      console.error("Error inserting IRS info:", error);
      toast.error("Failed to insert IRS info");
    }
  };
  //==========================================================

  const isSaveButtonVisible = () => {
    return ProductShipment.every(
      (shipment) => shipment.SHPD_ShipQty === shipment.SHPD_ScanQty
    );
  };

  const handleViewClick = async (SHPH_ShipmentID, PL_ProductCode) => {
    try {
      const res = await fetch(
        `${config.API_URL}/ProductWise_Outward_ViewData/${SHPH_ShipmentID}/${selectedScpId}/${PL_ProductCode}`,
        {
          method: "GET",
        }
      );
      if (res.ok) {
        const data = await res.json();
        setPopupData(data.ProductShipData); // Store the fetched data
        setPopupVisible(true); // Show the popup
      } else {
        toast.error("Failed to retrieve view data");
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
      toast.error("Error fetching view data");
    }
  };

  const handleClosePopup = () => {
    setPopupVisible(false); // Close the popup
    setPopupData(null); // Clear the popup data
  };
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    // logAction(`Select opened: ${selectName}`);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    // logAction("Select closed");
  };

const handleRowClick = (shipment) => {
  // Save clicked shipment + product info in state
  setSelectedShipmentID(shipment.SHPD_ShipmentMID);
  setSelectedProductID(shipment.PL_ProductId); // Set the product code as the selected product ID

  console.log("Row clicked →", {
    ProductName: shipment.SHPD_ProductName,
    ProductID: shipment.SHPD_ProductCode, // Use the actual product code
    ProductCode: shipment.PL_ProductCode,
    AvlQTY: shipment.inv_availableqty,
    ScanQty: shipment.SHPD_ScanQty,
  });
};

  return (
    <>
      {/* <Sto /> */}
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      <div className="main_container">
        <h4 className="formHeading">Product wise scanning</h4>
        <div className="">
          <div className="row">
            <div className="col-md-4">
              <div className="mb-3">
                <label className="form-label">Product Name</label>
                <div className="select-container">
                  <Select
                    options={ProductNames}
                    value={ProductNames.find(
                      (option) => option.value === SelectedProduct
                    )}
                    onChange={HandleProductChange}
                    placeholder="Select Product Name"
                    className="routing_select-box"
                    isSearchable
                    isOptionDisabled={(option) => option.isDisabled} // Disable already-selected options
                    styles={{
                      option: (base, state) => ({
                        ...base,
                        color: state.isDisabled ? "#999" : base.color,
                        backgroundColor: state.isDisabled
                          ? "#fff"
                          : base.backgroundColor,
                        cursor: state.isDisabled ? "not-allowed" : "default",
                      }),
                    }}
                    onMenuOpen={() => handleSelectOpen('Product')}
                    onMenuClose={handleSelectClose}
                />
                <div className='icon-container'>
                    {isSelectOpen === 'Product' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="mb-3">
              <div className="d-flex align-items-center">
                  <label
                    className="form-label"
                    style={{ marginBottom: "-5px" }}
                  >
                    RSN
                  </label>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "-25px",
                    }}
                  >
                    <input
                      type="radio"
                      name="inputMode"
                      value="manual"
                      checked={inputMode === "manual"}
                      onChange={() => handleInputModeChange("manual")}
                      style={{
                        accentColor: "black",
                        marginRight: "-25px",
                      }}
                    />
                    <label style={{ margin: "0" }}>Manual</label>
                  </div>
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "-25px",
                    }}
                  >
                    <input
                      type="radio"
                      name="inputMode"
                      value="scan"
                      checked={inputMode === "scan"}
                      onChange={() => handleInputModeChange("scan")}
                      style={{
                        accentColor: "black",
                        marginRight: "-25px",
                      }}
                    />
                    <label style={{ margin: "0" }}>Scan</label>
                  </div>
                </div>

                {inputMode === "manual" && (
                  <div className="d-flex align-items-center mt-2">
                    <div
                      className="input-group"
                      style={{ flexGrow: 1, marginRight: "10px" }}
                    >
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Enter RSN"
                        ref={inputRef} // Use the inputRef to reference this input element
                        value={ScannedResultForProduct || ""}
                        onChange={HandleInputChange}
                        disabled={!SelectedProduct && !manualInputEnabled} // Disabled until product is selected or manual input is enabled
                        style={{ width: "100%" }}
                      />
                    </div>
                    <button
                      className="btn btn-dark"
                      onClick={handleManualSubmit}
                    >
                      SUBMIT
                    </button>
                  </div>
                )}
                {inputMode === "scan" && (
                  <div className="d-flex align-items-center mt-2">
                    <div
                      className="input-group"
                      style={{ flexGrow: 1, marginRight: "10px" }}
                    >
                      <input
                        type="text"
                        className="form-input"
                        placeholder="Scan RSN"
                        ref={inputRef}
                        defaultValue=""
                        onChange={HandleScanChangeForProduct}
                        onPaste={preventPaste}
                        onKeyDown={handleKeyDown} // Handle scanner input
                        disabled={!SelectedProduct} // Disable until a product is selected
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-9">
            <div className="tableScanContainer ">
              <table className="scantableClass">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th className="nav-tabs">Product Name </th>
                    <th className="nav-tabs">Product Code </th>
                    <th className="nav-tabs">Available Qty</th>
                    <th className="nav-tabs">Scanned Qty</th>
                    <th className="nav-tabs">Shipment Details</th>
                  </tr>
                </thead>
              
                <tbody>
  {selectedProductShipment.map((shipment, index) => {
    const isSelected = SelectedShipmentID === shipment.SHPD_ShipmentMID;
    const isCompleted = shipment.SHPD_ShipQty === shipment.SHPD_ScanQty;
    
    return (
      <tr
        key={shipment.SHPD_ShipmentMID}
        onClick={() => handleRowClick(shipment)}
        className={
          isSelected 
            ? isCompleted ? "highlight" : "auto-highlight" 
            : ""
        }
        style={{
          cursor: isCompleted ? 'not-allowed' : 'pointer',
          opacity: isCompleted ? 0.6 : 1
        }}
      >
        <td>{index + 1}</td>
        <td>{shipment.SHPD_ProductName}</td>
        <td>{shipment.PL_ProductCode}</td>
        <td>{shipment.inv_availableqty}</td>
        <td>{shipment.SHPD_ScanQty}</td>
        <td>
          <img
            src={Icon9}
            alt="Pool"
            title="View"
            className="pool-button"
            onClick={() =>
              handleViewClick(
                shipment.SHPH_ShipmentID,
                shipment.PL_ProductCode
              )
            }
          />
        </td>
      </tr>
    );
  })}
</tbody>
              </table>
            </div>
            {SelectedProduct && selectedProductShipment.length === 0 && (
              <div>
                No ProductShipment available for the selected Product Name
              </div>
            )}
          </div>
          {popupVisible && popupData && (
            <div className="popup-box">
              <div className="popup-content">
                <h4>Shipment Details</h4>
                <div className="tableScanContainer ">
                  <table className="scantableClass">
                    <thead>
                      <tr>
                        <th>SCP Name</th>
                        <th>Product Name</th>
                        <th>Product Code</th>
                        <th>Shipment Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {popupData.map((item, index) => (
                        <tr key={index}>
                          <td>{item.SCPM_Name}</td>
                          <td>{item.SHPD_ProductName}</td>
                          <td>{item.SHPD_ProductCode}</td>
                          <td>{item.SHPD_ShipQty}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button
                    className="btn-cancle button-Close-Popup"
                    onClick={handleClosePopup}
                  >
                    CLOSE
                  </button>
                </div>
              </div>
            </div>
          )}
         
          <div className="col-md-3">
            <div className="scanContainer">
              <p className="scannedHeading">Scanned RSN List</p>
          
              <div>
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="selectAll"
                  onChange={handleSelectAllChange}
                />
                <label className="form-check-label" htmlFor="selectAll">
                  Select All
                </label>
              </div>
          
              {/* Deduplicated RSN string list */}
              {[...new Set(RSN.split("\n").filter((line) => line.trim() !== ""))].map(
                (line, index) => (
                  <div key={index}>
                    {/* <label>{line}</label> */}
                  </div>
                )
              )}
          
              {/* Deduplicated RSN tree */}
              {rsnTree &&
                rsnTree.map((rootNode) =>
                  renderRSNNode(rootNode, 0, rootNode.isRoot)
                )}
            </div>
          </div>

          <div className="button-container mt-2">
            <button
              onClick={removeSelectedItemsAndUpdateStatus}
              className="scan_btn"
            >
              REMOVE SELECTED
            </button>
          </div>
        </div>
      </div>

      <div className="button-container">
        {isSaveButtonVisible() && (
          <button
            className="save_btn"
            onClick={handleSave}
            disabled={
              isSaveButtonDisabled || (!SelectedProduct && !manualInputEnabled)
            } // Step 3: Disable based on state and existing conditions
          >
            SAVE
          </button>
        )}

        {isPopupVisibleRSN && (
          <div className="popup-box">
            <div className="popup-content-Suspend">
              <h5 className="Suspend-Popup-Heading">:: User Confirmation ::</h5>
              <p className="Suspend-Popup-Text">{message}</p>
              <div>
                <button
                  className="button-Confirm-Popup"
                  onClick={handlePopupConfirm}
                >
                  YES
                </button>
                <button
                  className="button-Close-Popup"
                  onClick={handlePopupClose}
                >
                  NO
                </button>
              </div>
            </div>
          </div>
        )}
        <Link 
        to={`/ShipOutScanPendingList`} 
        className="list_btn" 
        type="button"
        onClick={() => sessionStorage.removeItem('shipmentTableData')}
        >
          LIST
        </Link>
      </div>
    </>
  );
}

export default ShipOutScanByProduct;

